function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD24D"
    },
    cx: 255.999,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EDB937"
    },
    cx: 255.999,
    cy: 421.644,
    rx: 182.283,
    ry: 14.369
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.222h380.036c12.486,0,22.7,10.217,22.7,22.703V324.03H43.282V89.925 C43.282,77.439,53.496,67.222,65.982,67.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M58.695,308.614h394.607V89.922c0-3.979-3.308-7.287-7.287-7.287H65.979 c-3.976,0-7.287,3.308-7.287,7.287v218.693H58.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.718,324.03v24.826c0,12.489-11.261,22.703-25.026,22.703H68.305 c-13.765,0-25.026-10.214-25.026-22.703V324.03h425.436H468.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.238,115.528h229.523h34.167c4.142,0,7.528,3.389,7.528,7.528v44.795v140.766H99.546V167.851 v-44.795c0-4.142,3.386-7.528,7.528-7.528h34.167H141.238z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M107.071,115.528h297.858c4.142,0,7.528,3.386,7.528,7.528v15.054H99.546v-15.054 c0-4.142,3.386-7.528,7.528-7.528C107.074,115.528,107.071,115.528,107.071,115.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.384,123.325h163.62c1.115,0,2.022,0.913,2.022,2.022v3.751c0,1.11-0.91,2.022-2.022,2.022 h-163.62c-1.107,0-2.02-0.907-2.02-2.022v-3.751C224.363,124.236,225.272,123.325,226.384,123.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M117.332,121.983c2.392,0,4.334,1.938,4.334,4.334c0,2.394-1.941,4.334-4.334,4.334 c-2.397,0-4.339-1.938-4.339-4.334C112.994,123.918,114.935,121.983,117.332,121.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB937"
    },
    d: "M134.44,121.983c2.397,0,4.334,1.938,4.334,4.334c0,2.394-1.938,4.334-4.334,4.334 c-2.392,0-4.334-1.938-4.334-4.334C130.106,123.918,132.047,121.983,134.44,121.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M151.552,121.983c2.392,0,4.334,1.938,4.334,4.334c0,2.394-1.941,4.334-4.334,4.334 c-2.397,0-4.339-1.938-4.339-4.334C147.214,123.918,149.155,121.983,151.552,121.983z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF5B62"
    },
    points: "245.195,224.356 269.423,224.356 210.801,308.614 186.574,308.614  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED4C54"
    },
    d: "M269.424,224.355h-24.229l38.973,56.014h24.229l-38.97-56.014L269.424,224.355L269.424,224.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M368.479,194.066l-60.085,86.305h-24.229l63.029-90.866l-24.58-6.457l66.613-26.215l-3.879,42.765 L368.479,194.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M179.936,157.805h75.091v3.722h-75.091V157.805z M179.936,166.448h53.814v3.722h-53.814V166.448z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.18,
    y: 207.873,
    style: {
      fill: "#EDB937"
    },
    width: 9.091,
    height: 25.716
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.373,
    y: 185.686,
    style: {
      fill: "#FF5B62"
    },
    width: 9.091,
    height: 47.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.565,
    y: 157.961,
    style: {
      fill: "#21D0C3"
    },
    width: 9.091,
    height: 75.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 255.999,
    cy: 346.801,
    r: 7.814
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.065,407.271l36.095,11.564H170.836l29.123-11.564v-35.712h105.104v35.712H305.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M305.065,407.271l-105.104-35.712h105.104V407.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.959,407.271h105.104l36.095,11.564v4.981h-85.161h-85.163v-4.981l29.123-11.564H199.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M179.936,176.127h75.091v3.722h-75.091V176.127z M179.936,184.77h53.814v3.722h-53.814V184.77z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.2460da0a80798df3c24d6c75dadc0024.svg";
export { ForwardRef as ReactComponent };